import { Injectable } from '@angular/core';
import { StorageKeys } from './storage.enum';

@Injectable({
  providedIn: 'root',
})
export class Storage {
  public setItem(key: StorageKeys, value: string): void {
    localStorage.setItem(key, value);
  }

  public getItem(key: StorageKeys): string {
    return localStorage.getItem(key);
  }

  public removeItem(key: StorageKeys): void {
    localStorage.removeItem(key);
  }

  public isEquals(key: StorageKeys, value: string): boolean {
    return localStorage.getItem(key) === value;
  }

  public isValue(key: StorageKeys): boolean {
    const value = localStorage.getItem(key);
    return (
      value !== null &&
      value !== 'null' &&
      value !== undefined &&
      value !== 'undefined'
    );
  }
}
